/** Regions offered in the phone number inputs, as cca2 country codes. */
export const supportedPhoneRegions = [
  'DK',
  'SE',
  'US',
  'TR',
  'NO',
  'AU',
  'GR',
  'DE',
  'NL',
  'PL',
  'GB',
] as const;
